import { type CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import { color, type ColorType } from '@wf/components';

import { RiskColor } from '../../../types/enums';

import styles from './RiskTooltipContent.module.scss';

interface IRiskTooltipContentProps {
  title: string;
  content: string;
  colorName: RiskColor;
}

const colorNameByRiskColor: Record<RiskColor, ColorType | ''> = {
  [RiskColor.GREEN]: 'success',
  [RiskColor.BLUE]: 'info',
  [RiskColor.YELLOW]: 'caution',
  [RiskColor.ORANGE]: 'warning',
  [RiskColor.RED]: 'error',
  [RiskColor.PURPLE]: 'indigo',
  [RiskColor.NONE]: '',
};

function RiskTooltipContent({ title, content, colorName }: IRiskTooltipContentProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      {content && <div className={styles.content}>{content}</div>}
      <div className={styles.divider} />
      <div className={styles.footer}>
        {t('LPCO Risk is considered')}:{' '}
        <span
          style={{ color: color(colorNameByRiskColor[colorName] as ColorType) } as CSSProperties}
          className={styles.color}
        >
          {t(colorName)}
        </span>
      </div>
    </div>
  );
}

export default RiskTooltipContent;
